import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { NzOutletModule } from "ng-zorro-antd/core/outlet";
import { UiAssigneeModule } from "../assignee/assignee.module";
import { UiIconModule } from "../icon/icon.module";
import { UiLabelModule } from "../label/label.module";
import { UiTagModule } from "../tag/tag.module";
import { UiCollapsePanelComponent } from "./components/collapse-panel/collapse-panel.component";
import { UiCollapseComponent } from "./components/collapse/collapse.component";

@NgModule({
  imports: [CommonModule, UiIconModule, UiTagModule, UiAssigneeModule, UiLabelModule, NzOutletModule],
  declarations: [UiCollapseComponent, UiCollapsePanelComponent],
  exports: [UiCollapseComponent, UiCollapsePanelComponent],
})
export class UiCollapseModule {}
